import type { RootState } from "_shared/_stores/redux-store";
import type { MessageFileInfoJSON } from "messaging/attachments/_schemas/message-file-info-schema";
import Message from "messaging/message";

/** What "attachment-processing-updated" carries: one file of one message, with its new processing (#6877). */
export type AttachmentProcessingUpdate = { messageId: string; forumId: string; attachment: MessageFileInfoJSON };

/**
 * The message as it is in the store, with one file replaced by its newer self. Undefined when the store
 * does not hold the message or the file: a conversation nobody has opened loads it fresh when it is.
 */
export function withUpdatedAttachment(state: RootState, update: AttachmentProcessingUpdate): Message | undefined {
  const message = state.messages.entries[update.forumId]?.data?.find((candidate) => candidate.id?.value === update.messageId);
  if (!message?.attachments.some((file) => file.id.value === update.attachment.id)) return undefined;

  const json = message.toJSON();
  return Message.fromJSON({
    json: {
      ...json,
      attachments: json.attachments?.map((file) => (file.id === update.attachment.id ? { ...file, ...update.attachment } : file)),
    },
  });
}
